module.exports = __webpack_public_path__ + "img/code-three.359b0d11.png";